import { Group } from '@mantine/core';

type ApartProps = React.ComponentProps<typeof Group> & React.PropsWithChildren;

export const Apart = ({ children, ...groupProps }: ApartProps) => {
  return (
    <Group justify="space-between" {...groupProps}>
      {children}
    </Group>
  );
};
